import React from 'react';
import {Route, Switch} from 'react-router-dom';
import { SelectionContextProvider } from 'components/SelectionContext';
import ErrorPage from 'pages/Error';
import useAuthCheck from 'hooks/useAuthCheck';

function App() {
  const valid = useAuthCheck();

  return (
    <SelectionContextProvider>
      <Switch>
        <Route path={'/error'}>
          <ErrorPage/>
        </Route>
        {valid &&
            <Switch>
              <Route path={'/'}>
                <ErrorPage/>
              </Route>
            </Switch>
        }
      </Switch>
    </SelectionContextProvider>
  );
}

export default App;
